import { Link, To } from 'react-router-dom';

// material-ui
import { SxProps } from '@mui/material/styles';
import ButtonBase from '@mui/material/ButtonBase';

// project imports
import { useAuthContext } from '@/providers';
import { getFirstAccessiblePath } from '@/menu-items/first-accessible-path';
import Logo from './LogoMain';
import LogoIcon from './LogoIcon';

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

export default function LogoSection({ isIcon, sx, to }: Props) {
  // Link-ul logo-ului duce la prima pagină accesibilă rolului curent.
  const { user } = useAuthContext();
  return (
    <ButtonBase disableRipple component={Link} to={to || getFirstAccessiblePath(user)} sx={sx} aria-label="Logo">
      {isIcon ? <LogoIcon /> : <Logo />}
    </ButtonBase>
  );
}
